export default __webpack_public_path__ + "static/media/blue_rec_pressed.519e8fe7.png";